import { get } from 'lodash';
// eslint-disable-next-line import/no-cycle
import MoveBack from './moveBack';
import views from './views';

class Terms {
  constructor(options) {
    this.elem = options.elem;
    this.currentPage = options.currentPage;
    this.prevPage = options.prevPage;
    this.moveBackBtn = options.moveBackBtn;
    this.mainContent = options.mainContent;
    this.take_survey_btn_text =
      options.take_survey_btn_text || Pollfish.ui.getText('take_survey_btn');
    this.take_survey_btn_class = options.take_survey_btn_class;
    this.data =
      '<div class="js-github-terms github-terms">Loading terms...</div>';
    this.templ = `
      <div id="data" class="terms-and-conditions">
        <h2 class="padding-md-horizontal">Terms &amp; Conditions <span class="custom-terms-link"> / <a href="#survey-terms" class="fw-400 text-sm">View survey terms</a></span></h2>
        <div class="terms-and-conditions__content">
          ${this.data}
        </div>
        <div id="survey-terms" class="custom-terms-and-conditions__content">
          <div class="survey-terms-content">Loading survey terms...</div>
        </div>
      </div>`;
  }

  render() {
    const { elem, currentPage, moveBackBtn, prevPage, templ } = this;

    $('.js-take-survey-btn').text(this.take_survey_btn_text);

    // NOTE: removing the classes after the gdpr page makes sense, because the responder from
    // that moment on will never return back to the initial page.
    if (prevPage === views.common.gdpr) {
      $('.js-take-survey-btn')
        .removeClass()
        .addClass('js-take-survey-btn btn btn-secondary');
    }

    // NOTE: This is for a fix where the translated text doesn't contain proper double-quotes
    //       around the className of the element. ex: <a href="\#\" class="\js-terms\">ToU</a>
    let elementSelector = elem;
    if (!$(elem).length) {
      elementSelector = '[class*=js-terms]';
    }

    $(elementSelector).tap((e) => {
      e.preventDefault();
      const { hasCustomTerms = false } = get(Pollfish, 'helper.json', {});

      $('body').attr('data-page', currentPage);

      // send event that the user has clicked on terms
      Pollfish.analytics.sendEvent(
        'general',
        'clickTerms',
        'Click Terms',
        1100,
      );

      // display terms
      Pollfish.ui.displayTerms({ showCustomTerms: hasCustomTerms });

      // render presentation container
      Pollfish.ui.applyMainContentTemplate(templ);

      setTimeout(() => {
        $('html, body').scrollTop(0);
      }, 0);

      new MoveBack({ moveBackBtn, prevPage }).render();
    });
  }
}

export default Terms;
